import React, { ReactNode, useState } from 'react';
import eventusLogo from '../../assets/eventus_logo.png';

interface AuthFormLayoutProps {
  heading: string;
  subtext?: string;
  children: ReactNode;
  showDefaultFooter?: boolean;
  footer?: ReactNode;
}

const AuthFormLayout: React.FC<AuthFormLayoutProps> = ({
  heading,
  subtext,
  children,
  showDefaultFooter = true,
  footer,
}) => {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <div className="auth-form-wrap w-full max-w-[400px]">
      <div className="auth-orb auth-orb--form" aria-hidden="true" />
      <div className="auth-panel relative z-10 w-full">
        <div className="mb-8 flex justify-center">
          <div className="auth-logo-wrap">
            {!logoFailed ? (
              <img
                src={eventusLogo}
                alt="Eventus Security"
                className="h-16 w-16 object-contain"
                onError={() => setLogoFailed(true)}
              />
            ) : (
              <div className="auth-logo-fallback" aria-hidden="true" />
            )}
          </div>
        </div>

        <h1 className="auth-heading text-center">{heading}</h1>
        {subtext && <p className="auth-subtext text-center">{subtext}</p>}

        <div className="mt-8">{children}</div>

        {footer ??
          (showDefaultFooter && (
            <p className="auth-footer mt-10 text-center">
              Secured access for authorized personnel only.
            </p>
          ))}
      </div>
    </div>
  );
};

export default AuthFormLayout;
